module.exports = __webpack_public_path__ + "static/img/equip_noble_ic_entry_worship.7ddd339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/equip_noble_ic_entry_worship.png
// module id = Bpyf
// module chunks = 0